module.exports = __webpack_public_path__ + "img/learnEnglishTitle.68c2ee95.png";